import { Search, Filter } from 'lucide-react'

function CompanyFilters({ searchTerm, onSearchChange, onClearFilters }) {
  return (
    <div className="card">
      <div className="card-content">
        <div className="flex items-center space-x-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-secondary-400" />
              <input
                type="text"
                placeholder="Search companies..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="input pl-10"
              />
            </div>
          </div>
          <button
            onClick={onClearFilters}
            className="btn-outline"
          >
            <Filter className="h-4 w-4 mr-2" />
            Clear
          </button>
        </div>
      </div>
    </div>
  )
}

export default CompanyFilters
